// src/api/client.ts
type ApiOpts = RequestInit & { parseJsonOnError?: boolean };

// База — всегда прод-функция
const FUNCTION_BASE = "https://europe-west4-persona5-8ba93.cloudfunctions.net/appFn";

export async function api<T>(path: string, opts: ApiOpts = {}): Promise<T> {
  // path должен начинаться с "/", например: "/client/me", "/admin/create-account"
  const url = `${FUNCTION_BASE}/api${path}`;

  const token = localStorage.getItem("token") || "";
  const res = await fetch(url, {
    method: "GET",
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });

  if (!res.ok) {
    const txt = await res.text();
    try {
      const j = JSON.parse(txt);
      throw new Error(j?.message || txt || `${res.status} ${res.statusText}`);
    } catch {
      throw new Error(txt || `${res.status} ${res.statusText}`);
    }
  }
  return res.json() as Promise<T>;
}
